<div class="bottom-menu" [ngClass]="[tabsService.footerActive? 'active' : '', tabsService.fullScreenMode? 'fullscreen' : '', tabsService.minimizeScreenMode ? 'minimized' : '', menuService.open ? 'open-menu': '']">
  <div class="fields">
    <div class="fields__container" [ngClass]="[tabsService.fullScreenMode? 'fullscreen' : '', tabsService.minimizeScreenMode? 'fullscreen' : '']">
      <div>
        <div class="minimize-btn" [ngStyle]="{'display': tabsService.minimizeScreenMode? 'none' : ''}" (click)="onMinimize()"></div>
        <div class="fullscreen-btn" [ngStyle]="{'display': tabsService.minimizeScreenMode? 'none' : ''}" (click)="onFullscreen()"></div>
      </div>

      <section class="tabs-container">
        <span class="change-btn prev" (click)="scrollTab(-1)" *ngIf="!atStart && getNumberOfVisibleTabs() >= minNumberTabsActivatesScroll">
          &lsaquo;</span>

        <ul class="tabs" [ngStyle]="{'transform': abc }">

          <ng-container *ngFor="let tab of tabsService.tabs;let i=index">
            <li *ngIf="tab.visible" [ngClass]="tab == tabsService.currentTab ? 'selected': ''" class="fields__container__tabs__processes"
              (click)="toggle(i);">
              <label title="{{getTabName(tab)}}">
                {{getTabName(tab)}}
                <span (click)="closeTab(i)">
                </span>
              </label>
            </li>

          </ng-container>
        </ul>
        <span class="change-btn next" *ngIf="!atEnd && getNumberOfVisibleTabs() >= minNumberTabsActivatesScroll" (click)="scrollTab(1)">&rsaquo;</span>
      </section>

      <app-feature-filter></app-feature-filter>
      <app-device></app-device>
      <app-interference-test-device></app-interference-test-device>
      <app-receiver></app-receiver>

      <app-interference-test></app-interference-test>
<!--      <app-interference-test-filter></app-interference-test-filter>-->
      <app-radar></app-radar>


      <app-calculation-procedures></app-calculation-procedures>
      <app-navaids></app-navaids>
      <app-coordinate-points></app-coordinate-points>
      <app-altitude-filter></app-altitude-filter>
<!--      <app-procedures></app-procedures>-->
<!--      <app-airspace-boundaries></app-airspace-boundaries>-->
      <app-create-navaid-from-map></app-create-navaid-from-map>
<!--      <app-procedure-navaid-association></app-procedure-navaid-association>-->
      <app-fom-check></app-fom-check>
      <app-navaids-filter></app-navaids-filter>
      <app-procedures-filter></app-procedures-filter>
<!--      <app-airspace-boundaries-filter></app-airspace-boundaries-filter>-->
      <app-coordinate-points-filter></app-coordinate-points-filter>
      <app-terrain-grid></app-terrain-grid>
      <app-horizon-tool></app-horizon-tool>
      <app-map-search></app-map-search>
      <app-multipath-tool></app-multipath-tool>
      <app-barometric-calculation></app-barometric-calculation>
      <app-coverage-quantitative-assessment-result></app-coverage-quantitative-assessment-result>
      <app-range-ring-tool></app-range-ring-tool>
      <app-performance-report></app-performance-report>
      <!--<app-trajetcory></app-trajetcory>-->
<!--      <app-trajetcory-filter></app-trajetcory-filter>-->
      <app-navaids-co-channels></app-navaids-co-channels>
<!--      <app-saam-traffic-filter></app-saam-traffic-filter>-->
      <app-cross-section></app-cross-section>
      <app-project-control></app-project-control>
      <app-azimuth-tool></app-azimuth-tool>
      <app-procedure-assessments></app-procedure-assessments>
      <app-analysis-tool></app-analysis-tool>
      <app-calculation-configuration></app-calculation-configuration>
      <app-self-training-tool></app-self-training-tool>
    </div>
  </div>
</div>
